var render = function render(){var _vm=this,_c=_vm._self._c;return _c('slo-button',{staticClass:"p-0",attrs:{"fill":"clear"},on:{"click":function($event){return _vm.addToDesignSpec()}}},[_c('SloIcon',{attrs:{"name":"FolderOpen"}}),_vm._v(" "),_c('span',[_vm._t("default",function(){return [_vm._v(_vm._s(_vm._f("t")('Add to DesignSpec')))]})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }